import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { adminApi } from "../../../api-client";
import { queryKeys } from "../../query-keys";

export function useAdminClubInvoices(clubId: string, status?: string) {
	return useQuery({
		queryKey: queryKeys.financeAdmin.invoices(clubId, status),
		queryFn: () => adminApi.finance.invoices.list(clubId, status),
		enabled: !!clubId,
	});
}

export function useAdminClubPayments(clubId: string) {
	return useQuery({
		queryKey: queryKeys.financeAdmin.payments(clubId),
		queryFn: () => adminApi.finance.payments.list(clubId),
		enabled: !!clubId,
	});
}

export function useAdminClubFinanceDashboard(clubId: string) {
	return useQuery({
		queryKey: queryKeys.financeAdmin.dashboard(clubId),
		queryFn: () => adminApi.finance.dashboard(clubId),
		enabled: !!clubId,
	});
}

export function useAdminClubMembershipFees(clubId: string) {
	return useQuery({
		queryKey: queryKeys.financeAdmin.membershipFees(clubId),
		queryFn: () => adminApi.finance.membershipFees.list(clubId),
		enabled: !!clubId,
	});
}

export function useAdminMarkClubInvoicesOverdue(clubId: string) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: () => adminApi.finance.invoices.markOverdue(clubId),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: queryKeys.financeAdmin.dashboard(clubId),
			});
			queryClient.invalidateQueries({
				queryKey: ["finance-admin", "clubs", clubId, "invoices"],
			});
			queryClient.invalidateQueries({
				queryKey: queryKeys.financeAdmin.payments(clubId),
			});
		},
	});
}
